import { useState, useRef, useEffect } from "react";
import { Phone, MessageSquare } from "lucide-react";
import { BUSINESS } from "@/lib/constants";

const NUM = BUSINESS.phoneHref.replace("tel:", "");

export const PhoneChoice = ({ className = "", children, testId, align = "right" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button type="button" data-testid={testId} onClick={() => setOpen((o) => !o)} className={className}>
        {children}
      </button>
      {open && (
        <div
          data-testid={`${testId}-menu`}
          className={`absolute mt-2 z-[60] min-w-[190px] bg-ink border border-surface-2 shadow-2xl ${
            align === "right" ? "right-0" : "left-0"
          }`}
        >
          <a
            href={BUSINESS.phoneHref}
            data-testid={`${testId}-call`}
            className="flex items-center gap-3 px-4 py-3 text-white hover:bg-surface hover:text-hazard font-mono text-sm uppercase tracking-[0.12em] border-b border-surface-2 transition-colors"
          >
            <Phone size={16} /> Call
          </a>
          <a
            href={`sms:${NUM}`}
            data-testid={`${testId}-text`}
            className="flex items-center gap-3 px-4 py-3 text-white hover:bg-surface hover:text-hazard font-mono text-sm uppercase tracking-[0.12em] transition-colors"
          >
            <MessageSquare size={16} /> Send Message
          </a>
        </div>
      )}
    </div>
  );
};
